import { AppUserRoles } from "../../config/constants";
import { StorageAuth } from "../../core/localStorage";
import { Settings } from "../../features/settings/settings.component";
import { useHistory } from "react-router";

export const PageSettings = () => {
  const userRole = StorageAuth.Role?.toLowerCase();
  const {
    location: { state },
  } = useHistory<{ expanded?: "task" | "account" | "password" | "email" }>();

  return (
    <Settings
      expandAccountSettings={!state?.expanded || state?.expanded === "account"}
      expandTaskSettings={state?.expanded === "task"}
      expandChangePassword={state?.expanded === "password"}
      expandEmailSettings={state?.expanded === "email"}
      hideTaskSettings={
        !!userRole && userRole === AppUserRoles.SuperAdmin.toLowerCase()
      }
      hideEmailSettings={
        !!userRole && userRole === AppUserRoles.SuperAdmin.toLowerCase()
      }
      hideGenerateInvoice={
        !!userRole && userRole !== AppUserRoles.SuperAdmin.toLowerCase()
      }
      hideDataExchange={
        !!userRole && userRole !== AppUserRoles.SuperAdmin.toLowerCase()
      }
    />
  );
};
